var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31407 14.9985C12.0418 14.9985 15.0637 11.9766 15.0637 8.24886C15.0637 4.52114 12.0418 1.49924 8.31407 1.49924C4.58636 1.49924 1.56445 4.52114 1.56445 8.24886C1.56445 11.9766 4.58636 14.9985 8.31407 14.9985Z",
    stroke: "#2A9562",
    strokeWidth: 1.68741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.751 16.6859L13.0809 13.0158",
    stroke: "#2A9562",
    strokeWidth: 1.68741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9760526c380ec6d87076e2050a5f71ba.svg";
export { ForwardRef as ReactComponent };